export default "__VITE_ASSET__BDwLwJ0B__"